import React, { Component } from 'react'
import ImageStrip    from './ImageStrip'
import ImageSettings from './ImageSettings'
import PostPreview   from './PostPreview'
import WrapperPageWithSecondNav from '../../WrapperPage/present/WrapperPageWithSecondNav'
import Translation from '../../Translation/cont/Translation'
import config from '../../../config.json'
import SOCIAL_MEDIA_FORMATS from '../../../constants/socialMediaFormats'
import ConfirmDialog from './dialogs/ConfirmDialog'
import hasSlideContent from '../../../functions/hasSlideContent'

const FORMATS = [...SOCIAL_MEDIA_FORMATS, { id: 'custom', label: 'Custom', width: null, height: null }]

const makeDefaultImage = () => ({
    movieId:           null,
    posterEnabled:     true,
    backdropEnabled:   false,
    backdropSource:    'movie',
    backdropUrl:       null,
    gradientEnabled:   true,
    titleEnabled:      true,
    titleText:         '',
    freetextEnabled:   false,
    freetextText:      '',
    dateEnabled:       false,
    dateMode:          'manual',
    dateManual:        '',
    performanceId:     null,
    presetId:          null,
    logoEnabled:       true,
    logoOverrideUrl:   null,
    borderEnabled:     true,
    badgeEnabled:    true,
    badgeText:       '',
    fskEnabled:        true,
    ctaEnabled:        false,
    ctaText:           '',
})

class PageSocialMediaPost extends Component {
    constructor(props) {
        super(props)
        this.state = {
            formatId:         'ig-feed-4-5',
            customWidth:      1080,
            customHeight:     1080,
            images:           [makeDefaultImage()],
            activeImageIndex: 0,
            pendingPresetId:  null,
        }
    }

    getActiveFormat() {
        return FORMATS.find(f => f.id === this.state.formatId) || FORMATS[0]
    }

    getActiveImage() {
        return this.state.images[this.state.activeImageIndex] || this.state.images[0]
    }

    updateActiveImage(changes) {
        const idx = this.state.activeImageIndex
        this.setState(prev => ({
            images: prev.images.map((img, i) => i === idx ? Object.assign({}, img, changes) : img)
        }))
    }

    addImage() {
        const { preset } = this.props
        const followupPresetId = preset && preset.settings && preset.settings.followup
            ? preset.settings.followup.presetId
            : null
        this.setState(prev => ({
            images:           [...prev.images, Object.assign(makeDefaultImage(), { presetId: followupPresetId || null })],
            activeImageIndex: prev.images.length,
        }))
    }

    removeImage(index) {
        this.setState(prev => {
            if (prev.images.length <= 1) return null
            const images = prev.images.filter((_, i) => i !== index)
            let activeImageIndex = prev.activeImageIndex
            if (index < activeImageIndex) {
                activeImageIndex -= 1
            } else if (index === activeImageIndex) {
                activeImageIndex = Math.min(activeImageIndex, images.length - 1)
            }
            return { images, activeImageIndex }
        })
    }

    moveImage(fromIndex, toIndex) {
        if (toIndex < 0 || toIndex >= this.state.images.length) return
        this.setState(prev => {
            const images = [...prev.images]
            const [moved] = images.splice(fromIndex, 1)
            images.splice(toIndex, 0, moved)
            const activeImageIndex = prev.activeImageIndex === fromIndex
                ? toIndex
                : prev.activeImageIndex
            return { images, activeImageIndex }
        })
    }

    handleDownload() {
        const { formatId, customWidth, customHeight, images } = this.state
        this.props.onDownload(images, formatId, customWidth, customHeight)
    }

    handlePresetSelect(newPresetId) {
        if (this.state.activeImageIndex === 0) {
            this.requestPresetChange(newPresetId)
        } else {
            this.updateActiveImage({ presetId: newPresetId })
        }
    }

    requestPresetChange(newPresetId) {
        if (hasSlideContent(this.state.images)) {
            this.setState({ pendingPresetId: newPresetId })
        } else {
            this.props.onPresetChange(newPresetId)
        }
    }

    confirmPresetChange() {
        const { pendingPresetId } = this.state
        this.setState({ pendingPresetId: null })
        this.props.onPresetChange(pendingPresetId)
    }

    cancelPresetChange() {
        this.setState({ pendingPresetId: null })
    }

    render() {
        const { formatId, customWidth, customHeight, images, activeImageIndex, pendingPresetId } = this.state
        const { preset, presets, movies, performances, cinemas, themeData, front, isDownloading, closePagePath, onPresetChange,
                translationStrings, currentLang, translationDebug } = this.props
        const activeImage  = this.getActiveImage()
        const activeFormat = this.getActiveFormat()
        const fw = formatId === 'custom' ? customWidth  : (activeFormat ? activeFormat.width  : 1080)
        const fh = formatId === 'custom' ? customHeight : (activeFormat ? activeFormat.height : 1350)

        return (
            <WrapperPageWithSecondNav
                pageTitleTransId={config.routes.socialMedia.transId}
                pageTitle={config.routes.socialMedia.name}
                closePagePath={closePagePath}
                navWide
                navChildren={
                    <>
                        <div className="post-generator__settings">
                            {preset && (
                                <div className="post-generator__settings-topbar">
                                    <span className="post-generator__settings-topbar-name text-small-bold">
                                        {preset.name}
                                    </span>
                                </div>
                            )}
                            <ImageSettings
                                formatId={formatId}
                                customWidth={customWidth}
                                customHeight={customHeight}
                                formats={FORMATS}
                                image={activeImage}
                                preset={preset}
                                presets={presets}
                                movies={movies}
                                performances={performances}
                                cinemas={cinemas}
                                translationStrings={translationStrings}
                                currentLang={currentLang}
                                translationDebug={translationDebug}
                                onFormatChange={id => this.setState({ formatId: id })}
                                onCustomWidthChange={w => this.setState({ customWidth: w })}
                                onCustomHeightChange={h => this.setState({ customHeight: h })}
                                onImageChange={changes => this.updateActiveImage(changes)}
                                onPresetChange={id => this.handlePresetSelect(id)}
                                slideTabs={
                                    <div className="post-generator__slide-tabs">
                                        {images.map((img, i) => (
                                            <div key={i}
                                                className={`post-generator__slide-tab${activeImageIndex === i ? ' is-active' : ''}`}
                                                onClick={() => this.setState({ activeImageIndex: i })}>
                                                <span className="post-generator__slide-tab-drag">⠿</span>
                                                <div className="post-generator__slide-tab-num">{i + 1}</div>
                                                <Translation id="social_media_section_image" /> {i + 1}
                                                {images.length > 1 && (
                                                    <button className="post-generator__slide-tab-remove"
                                                        onClick={e => { e.stopPropagation(); this.removeImage(i) }}>×</button>
                                                )}
                                            </div>
                                        ))}
                                        <button className="post-generator__slide-tab-add" onClick={() => this.addImage()}>+</button>
                                    </div>
                                }
                            />
                        </div>
                        <div className="post-generator__strip">
                            <ImageStrip
                                images={images}
                                activeImageIndex={activeImageIndex}
                                onSelectImage={i => this.setState({ activeImageIndex: i })}
                                onAddImage={() => this.addImage()}
                                onRemoveImage={i => this.removeImage(i)}
                                onMoveImage={(from, to) => this.moveImage(from, to)}
                            />
                        </div>
                    </>
                }
            >
            <div className="page-social-media-post site-content">
                <div className="post-generator">
                    <div className="post-generator__preview">
                        <div className="post-generator__preview-topbar">
                            <span className="post-generator__preview-title text-small-bold">
                                <Translation id="button_preview" />
                            </span>
                            <span className="post-generator__preview-subtitle text-xsmall-light">
                                <Translation id="social_media_section_image" /> {activeImageIndex + 1} / {images.length} · {activeFormat ? activeFormat.label : ''}
                            </span>
                        </div>
                        <div className="post-generator__preview-body">
                            <div>
                                <PostPreview
                                    image={activeImage}
                                    preset={preset}
                                    presets={presets}
                                    format={activeFormat}
                                    formatId={formatId}
                                    customWidth={customWidth}
                                    customHeight={customHeight}
                                    movies={movies}
                                    performances={performances}
                                    themeData={themeData}
                                    front={front}
                                />
                                <div className="post-generator__preview-label text-xsmall-light">
                                    {fw} × {fh} px · <Translation id="social_media_section_image" /> {activeImageIndex + 1} / {images.length}
                                </div>
                            </div>
                            <button className="post-generator__preview-add" onClick={() => this.addImage()}>
                                + <Translation id="social_media_add_image" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="buttons-submit-cancel">
                <button className="button button-submit"
                    disabled={isDownloading}
                    onClick={() => this.handleDownload()}>
                    <span className="text">
                        {isDownloading
                            ? <Translation id="social_media_downloading" />
                            : <Translation id="social_media_download" />}
                    </span>
                </button>
            </div>
            {pendingPresetId && (
                <ConfirmDialog
                    titleTransId="social_media_preset_switch_confirm_title"
                    bodyTransId="social_media_preset_switch_confirm_body"
                    onConfirm={() => this.confirmPresetChange()}
                    onCancel={() => this.cancelPresetChange()}
                />
            )}
            </WrapperPageWithSecondNav>
        )
    }
}

export default PageSocialMediaPost
